module.exports = __webpack_public_path__ + "9203b17ae49164aaed23f53e056961e0.svg";